import { useGetFetch } from '../reactQuery';
import { PRODUCT_BANK_API } from '../../../constant/api_url';
import { Input } from '../../../types/input.types';

export const useConnectedInputsToProductBank = (id: string | number) =>
  useGetFetch<Input[]>(`${PRODUCT_BANK_API}/${id}/input`);
